export const DATE_TYPE = {
  NORMAL: 0,
};
